// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__tY7-W","backToTopVisible":"BackToTop_backToTopVisible__-tvGs","triggerPoint":"BackToTop_triggerPoint__bcx0L"};